import { ref } from "vue";
import type { PreRegistrationValidationData } from "@/app/registration-app/user/shared/@types/PreRegistrationValidationData";
import {
  validatePreRegistrationData,
  serializeDataForValidatePreRegistrationData,
} from "@/app/registration-app/user/shared/services/validatePreRegistrationData.service";

export const useValidatePreRegistrationData = () => {
  const isValidatingData = ref(false);
  const validatingDataError = ref<string>();
  const isManagedCustomer = ref(false);

  const onValidatingPreRegistrationData = async (
    data: PreRegistrationValidationData,
  ) => {
    try {
      isValidatingData.value = true;
      validatingDataError.value = undefined;
      isManagedCustomer.value = false;

      isManagedCustomer.value = await validatePreRegistrationData(
        serializeDataForValidatePreRegistrationData(data),
      );
    } catch (error) {
      validatingDataError.value = error as string;
    } finally {
      isValidatingData.value = false;
    }
  };

  return {
    isValidatingData,
    validatingDataError,
    isManagedCustomer,
    onValidatingPreRegistrationData,
  };
};
